import React from 'react'
import { RecoverPasswordForm } from '../form/RecoverPasswordForm'


export const RecoverPassword = () => {
  return (
   <RecoverPasswordForm/>
  )
}
